export function sanitizeStoreInternalURL(url: string): string {
  const urlWithoutSpaces = url.trim().replace(/\s/g, '-');
  return urlWithoutSpaces.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
}
